
import { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-16 sm:pt-20 md:pt-24">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
